import { atom } from 'jotai';

import type { CampaignEditorSectionIssue } from '../campaign-editor-types';

type CampaignInfoIssue = Extract<CampaignEditorSectionIssue, { section: 'campaign-info' }>;

export const campaignInfoIssueAtom = atom<CampaignInfoIssue | undefined>({
  section: 'campaign-info',
  reason: 'incomplete',
});
